import { Logger, Presenter } from 'wdc-cube'
import * as lang from 'src/utils/lang'
import { TheConsumerMarketPresenter } from './tcm_presenter'
import { TextualSearchScope } from './tcm_scopes'
import { TheConsumerMarketKeys } from './tcm_keys'
import { MainPresenter } from 'src/main'
import { TheConsumerMarketService } from './tcm_service'

const LOG = Logger.get('TcmPresenterSearchBar')

const service = TheConsumerMarketService.singleton()

export default class TcmPresenterSearchBar extends Presenter<TextualSearchScope, TheConsumerMarketPresenter> {
    // :: Class methods

    constructor(owner: TheConsumerMarketPresenter) {
        super(owner, (owner.scope.header.textualSearch = new TextualSearchScope()))
        this.__parent = owner
        this.__app = owner.app
    }

    // :: Instance

    private readonly __app: MainPresenter
    private readonly __parent: TheConsumerMarketPresenter

    // :: API

    async initialize() {
        this.scope.onSearch = this.action(this.handleOnSearch)
        LOG.debug('Initialized')
    }

    async applyParameters(keys: TheConsumerMarketKeys, initialization: boolean) {
        // TODO
    }

    protected async handleOnSearch() {
        const app = this.__app
        try {
            this.scope.waiting = true

            const textualRequest = this.scope.text.trim()
            if (textualRequest.length == 0) {
                app.alert(
                    'warning',
                    'Notificação',
                    'Para fazer a consulta é necessário informar uma mensagem para a IA'
                )
                return
            }

            const empFilter = await service.fetchFilterByIA(textualRequest)
            if (!empFilter) {
                app.alert(
                    'error',
                    'Filtro gerado',
                    'Por alguma característica da mensagem solicitada o filtro não foi gerado'
                )
                return
            }

            await this.__parent.filterPane.apply(empFilter)

            app.notify('success', `Filtro de IA aplicado`)

            this.scope.text = ''
        } catch (exn) {
            console.error(exn)
            const error = lang.toError(exn)
            app.alert('error', 'Erro Inesperado', error.message)
        } finally {
            this.scope.waiting = false
            this.scope.update()
        }
    }
}
